import React, { useEffect } from 'react';

const MIN_HEIGHT = 80;

const useTextareaHeightFitContent = (ref: React.RefObject<HTMLTextAreaElement>) => {
  const listener = () => {
    if (!ref || !ref.current) return;
    ref.current.style.height = '0px';
    const scrollHeight = ref.current?.scrollHeight > MIN_HEIGHT ? ref.current?.scrollHeight : MIN_HEIGHT;
    ref.current.style.height = `${scrollHeight}px`;
  };

  useEffect(() => {
    if (!ref?.current) return;
    listener();
  }, [ref.current]);

  useEffect(() => {
    window.addEventListener('resize', listener);
    ref?.current?.addEventListener('input', listener);
    return () => {
      window.removeEventListener('resize', listener);
      ref.current?.removeEventListener('input', listener);
    };
  }, [ref.current]);
};

export default useTextareaHeightFitContent;
